// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- OpenCart Admin – Pixel-like Theme for your React app --- */

/* Font to match OC admin */

:root{
  --oc-bg: #f5f5f5;
  --oc-panel: #ffffff;
  --oc-border: #e3e3e3;
  --oc-text: #333;
  --oc-muted: #888;
  --oc-blue: #23a1d1;       /* OC blue accents */
  --oc-blue-700:#1f91bd;
  --oc-blue-100:#e9f6fb;
  --oc-table-head:#f7f7f7;
  --oc-table-row:#fff;
  --oc-table-row-alt:#fafafa;
  --oc-danger:#d9534f;
  --oc-success:#5cb85c;
  --oc-warning:#f0ad4e;
  --oc-link:#1e91bd;
}

/* Layout */
html,body,#root{height:100%;}
body{margin:0;font-family:'Open Sans', Arial, sans-serif;color:var(--oc-text);background:var(--oc-bg);}

/* main grid: sidebar + content */
.oc-shell{display:grid;grid-template-columns: 230px 1fr;min-height:100vh;}
.oc-sidebar{background:#1f2d3d;color:#cfd8dc;}
.oc-brand{display:flex;align-items:center;gap:10px;padding:14px 16px;border-bottom:1px solid #202b35;}
.oc-brand img{height:22px}
.oc-nav{padding:8px 0;}
.oc-nav .group-title{font-size:12px;color:#90a4ae;text-transform:uppercase;padding:10px 16px;}
.oc-nav ul{margin:0;padding:0;list-style:none}
.oc-nav li{display:block}
.oc-nav a, .oc-nav button{display:flex;gap:8px;align-items:center;width:100%;padding:10px 16px;color:#cfd8dc;background:none;border:0;text-align:left;cursor:pointer}
.oc-nav a:hover,.oc-nav button:hover{background:#17212b;color:#fff}
.oc-nav li.active > a{background:#17212b;color:#fff}

/* top bar */
.oc-topbar{background:var(--oc-panel);border-bottom:1px solid var(--oc-border);height:54px;display:flex;align-items:center;padding:0 12px;gap:8px;}
.oc-topbar-left {display:flex;align-items:center;gap:16px;margin-right:auto;}
.oc-menu-btn {display:none;align-items:center;gap:8px;background:#fff;border:1px solid var(--oc-border);border-radius:4px;padding:6px 12px;cursor:pointer;color:var(--oc-text);font-size:13px;font-weight:600;}
.oc-menu-btn:hover {background:var(--oc-table-head);}

@media (max-width: 768px) {
  .oc-shell {grid-template-columns: 1fr;}
  .oc-sidebar {position:fixed;left:-230px;top:0;bottom:0;z-index:1000;transition:left 0.3s ease;}
  .oc-shell.is-sidebar-open .oc-sidebar {left:0;}
  .oc-menu-btn {display:flex;}
  .oc-overlay {display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:999;}
  .oc-shell.is-sidebar-open .oc-overlay {display:block;}
}

.oc-active-market-label {display:flex;align-items:center;gap:8px;color:var(--oc-blue);font-size:13px;font-weight:600;}
.oc-ico-btn{border:1px solid var(--oc-border);background:#fff;border-radius:4px;padding:6px 10px;cursor:pointer}
.oc-ico-btn.primary{background:var(--oc-blue);color:#fff;border-color:var(--oc-blue)}
.oc-marketplace-switcher{display:flex;align-items:center;gap:6px;color:var(--oc-blue)}
.oc-marketplace-switcher select{min-width:170px;max-width:240px;padding:5px 8px}
.oc-user{display:flex;align-items:center;gap:10px;margin-left:6px}
.oc-user-info{display:flex;flex-direction:column;align-items:flex-end;gap:1px;}
.oc-user-name{font-size:12px;font-weight:600;line-height:1.2;color:var(--oc-text);}
.oc-user-role{font-size:11px;color:var(--oc-muted);line-height:1.2;}
.oc-avatar{width:32px;height:32px;border-radius:50%;background:#1f2d3d;color:#fff;display:grid;place-items:center;font-size:12px;font-weight:600;text-transform:uppercase;}

/* page wrap */
.oc-main{display:grid;grid-template-rows:54px 1fr;}
.oc-content{padding:18px;}
.oc-header{display:flex;align-items:baseline;gap:10px;margin:12px 0;}
.oc-header h1{margin:0;font-weight:600;font-size:24px}
.oc-bc{color:#999;font-size:13px}
.oc-bc .sep{padding:0 6px;color:#bbb}

/* cards / panels */
.oc-card{background:var(--oc-panel);border:1px solid var(--oc-border);border-radius:4px;padding:12px;margin-bottom:16px;border:2px solid #000;}

/* filter block */
.oc-filter .title{font-weight:600;font-size:14px;margin-bottom:10px;color:#555;display:flex;align-items:center;gap:8px}

.oc-filter .oc-f-grid,
.oc-filter .orders-filter-grid,
.oc-filter [style*="grid-template-columns"] {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 8px !important;
  align-items: flex-end !important;
}

.oc-filter .oc-field,
.oc-filter [style*="grid-template-columns"] > div {
  flex: 1 1 140px !important;
  min-width: 140px !important;
  width: auto !important;
}

/* string inputs should be larger */
.oc-filter .oc-field.large,
.oc-filter .large,
.oc-filter [style*="grid-template-columns"] > div.large {
  flex: 1 1 200px !important;
  min-width: 200px !important;
}

.oc-filter .oc-checks,
.oc-filter [style*="grid-template-columns"] > div.oc-checks {
  flex: 1 1 auto !important;
  width: auto !important;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.oc-filter .oc-actions,
.oc-filter [style*="grid-template-columns"] > div.oc-actions {
  flex: 1 1 100% !important;
  width: 100% !important;
  margin-left: 0;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
}

.oc-f-grid{display:grid;grid-template-columns: repeat(5, minmax(0, 1fr));gap:12px;align-items:end}

.oc-field{display:grid;gap:6px}
.oc-field label{font-size:12px;color:#666}
.oc-input, .oc-select {
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 0 12px;
  background: #fff;
  font-size: 14px;
  line-height: 1.5;
  display: inline-block;
  vertical-align: middle;
}
.oc-checks{grid-column:1 / -2;display:flex;flex-wrap:wrap;gap:14px;color:#333}
.oc-actions{display:flex;gap:8px;justify-content:flex-end}
.oc-btn{background:var(--oc-blue);color:#fff;border:1px solid var(--oc-blue);border-radius:3px;padding:6px 12px;cursor:pointer}
.oc-btn.ghost{background:#fff;color:#333;border:1px solid #cfcfcf}
.oc-btn:disabled{opacity:.5;cursor:not-allowed}

/* table */
.oc-toolbar{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px}
.oc-table-wrap{overflow:auto;border:1px solid var(--oc-border);border-radius:4px}
.oc-table{width:100%;border-collapse:collapse;background:#fff;min-width:1100px}
.oc-table th,.oc-table td{padding:10px 12px;border-bottom:1px solid var(--oc-border);font-size:13px}
.oc-table thead th{background:var(--oc-table-head);font-weight:600;color:#555}
.oc-table tbody tr:nth-child(odd){background:var(--oc-table-row)}
.oc-table tbody tr:nth-child(even){background:var(--oc-table-row-alt)}
.oc-mono{font-family:Menlo,Consolas,monospace}
.oc-row-actions{display:flex;gap:6px}

/* status labels like OC */
.oc-badge{display:inline-block;padding:3px 8px;border-radius:3px;font-size:12px;font-weight:600}
.oc-badge.blue{background:#d9eef7;color:#1e6c8a}
.oc-badge.green{background:#e2f4e6;color:#2e7d32}
.oc-badge.amber{background:#fff0d6;color:#8a5a00}
.oc-badge.gray{background:#eee;color:#555}
.oc-badge.red{background:#fdecea;color:#c62828}
.oc-badge.purple{background:#f3e5f5;color:#6a1b9a}
.oc-badge.teal{background:#e0f2f1;color:#00695c}
.oc-badge.orange{background:#fff3e0;color:#e65100}
.oc-badge.pink{background:#fce4ec;color:#ad1457}






.badge { display:inline-block; padding:3px 8px; border-radius:3px; font-size:12px; font-weight:600; background:#eee; color:#333 }


/* tabs row within card */
.tabs{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:10px}
.tab{display:inline-flex;align-items:center;background:#fff;border:1px solid var(--border);border-radius:3px;padding:6px 10px;text-decoration:none;color:#333}
.tab:hover{background:#f7f7f7}
.tab.muted{pointer-events:none;color:#777}

/* metrics row */
.metrics{display:flex;gap:8px;flex-wrap:wrap;margin-top:6px}

/* 2-column split */
.split-2{display:grid;grid-template-columns:1fr 1fr;gap:16px}
.section-title{font-weight:600;margin-bottom:6px}

.store-row{display:flex;align-items:end;gap:8;margin-top:12px}
.field.slim{max-width:280px}

/* Add product card */
.add-product{margin-top:12px}

/* tabbar for notes/history */
.tabbar{display:flex;gap:8px;border-bottom:1px solid var(--border);margin-bottom:12px}
.tabbtn{border:1px solid var(--border);background:#fff;border-bottom:0;padding:6px 10px;border-radius:3px 3px 0 0;cursor:pointer}
.tabbtn.active{background:#f7f7f7;font-weight:600}

/* misc */
.muted{color:#666}
.muted.small{font-size:12px}
.title{font-weight:600}
.packed{display:flex;align-items:center;gap:6px}





.order-summary-row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
}

.order-actions{
  display:flex;
  gap:6px;
  flex-wrap:wrap;
}

/* If you don't load Bootstrap, add minimal button colors */
.btn-info{ background:#5bc0de; border:1px solid #46b8da; color:#fff }
.btn-primary{ background:#337ab7; border:1px solid #2e6da4; color:#fff }
.btn-default{ background:#fff; border:1px solid #ccc; color:#333 }
.btn{ padding:6px 10px; border-radius:4px; display:inline-flex; align-items:center; gap:6px; text-decoration:none; }
.btn i{ line-height:1 }





.oc-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.oc-modal {
  background: #fff;
  border-radius: 4px;
  width: 800px;
  max-width: 95%;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);
  border: 1px solid #ccc;
}

.oc-modal-header,
.oc-modal-footer {
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.oc-modal-footer {
  border-top: 1px solid #eee;
  border-bottom: none;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.oc-modal-body {
  padding: 12px 16px 4px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 16px;
  margin-bottom: 8px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.form-group.checkbox {
  flex-direction: row;
  align-items: center;
  gap: 6px;
}

.oc-input {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 14px;
  line-height: 1.5;
}







.oc-table {
  width: 100%;
  border-collapse: collapse;
}

.oc-table th,
.oc-table td {
  padding: 8px 10px;
  border: 1px solid #ddd;
  vertical-align: middle;
}

.oc-thumb {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

.oc-textarea {
  min-height: 80px;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 14px;
  resize: vertical;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 16px;
  margin-bottom: 8px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}









.oc-image-upload {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.oc-image-upload-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.oc-input-file {
  font-size: 13px;
  padding: 4px 0;
}

.oc-btn-upload {
  padding-inline: 12px;
  height: 32px;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.oc-image-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.oc-image-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.oc-image-preview {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
}

.oc-image-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.oc-field-error {
  margin-top: 2px;
  font-size: 12px;
  color: #b91c1c;
}

`, "",{"version":3,"sources":["webpack://./src/style/opencart-admin.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE,2BAA2B;;AAG3B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB,QAAQ,oBAAoB;EAC9C,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,WAAW;AACX,gBAAgB,WAAW,CAAC;AAC5B,KAAK,QAAQ,CAAC,0CAA0C,CAAC,oBAAoB,CAAC,uBAAuB,CAAC;;AAEtG,iCAAiC;AACjC,UAAU,YAAY,CAAC,gCAAgC,CAAC,gBAAgB,CAAC;AACzE,YAAY,kBAAkB,CAAC,aAAa,CAAC;AAC7C,UAAU,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,iBAAiB,CAAC,+BAA+B,CAAC;AACrG,cAAc,WAAW;AACzB,QAAQ,aAAa,CAAC;AACtB,qBAAqB,cAAc,CAAC,aAAa,CAAC,wBAAwB,CAAC,iBAAiB,CAAC;AAC7F,WAAW,QAAQ,CAAC,SAAS,CAAC,eAAe;AAC7C,WAAW,aAAa;AACxB,0BAA0B,YAAY,CAAC,OAAO,CAAC,kBAAkB,CAAC,UAAU,CAAC,iBAAiB,CAAC,aAAa,CAAC,eAAe,CAAC,QAAQ,CAAC,eAAe,CAAC,cAAc;AACpK,qCAAqC,kBAAkB,CAAC,UAAU;AAClE,sBAAsB,kBAAkB,CAAC,UAAU;;AAEnD,YAAY;AACZ,WAAW,0BAA0B,CAAC,wCAAwC,CAAC,WAAW,CAAC,YAAY,CAAC,kBAAkB,CAAC,cAAc,CAAC,OAAO,CAAC;AAClJ,iBAAiB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,iBAAiB,CAAC;AAC5E,cAAc,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,eAAe,CAAC,iCAAiC,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,cAAc,CAAC,oBAAoB,CAAC,cAAc,CAAC,eAAe,CAAC;AAC9M,oBAAoB,+BAA+B,CAAC;;AAEpD;EACE,WAAW,0BAA0B,CAAC;EACtC,aAAa,cAAc,CAAC,WAAW,CAAC,KAAK,CAAC,QAAQ,CAAC,YAAY,CAAC,yBAAyB,CAAC;EAC9F,uCAAuC,MAAM,CAAC;EAC9C,cAAc,YAAY,CAAC;EAC3B,aAAa,YAAY,CAAC,cAAc,CAAC,OAAO,CAAC,0BAA0B,CAAC,WAAW,CAAC;EACxF,uCAAuC,aAAa,CAAC;AACvD;;AAEA,yBAAyB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,oBAAoB,CAAC,cAAc,CAAC,eAAe,CAAC;AACrH,YAAY,iCAAiC,CAAC,eAAe,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,cAAc;AAC/G,oBAAoB,yBAAyB,CAAC,UAAU,CAAC,2BAA2B;AACpF,yBAAyB,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,oBAAoB;AACrF,gCAAgC,eAAe,CAAC,eAAe,CAAC,eAAe;AAC/E,SAAS,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,eAAe;AACjE,cAAc,YAAY,CAAC,qBAAqB,CAAC,oBAAoB,CAAC,OAAO,CAAC;AAC9E,cAAc,cAAc,CAAC,eAAe,CAAC,eAAe,CAAC,oBAAoB,CAAC;AAClF,cAAc,cAAc,CAAC,qBAAqB,CAAC,eAAe,CAAC;AACnE,WAAW,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,UAAU,CAAC,YAAY,CAAC,kBAAkB,CAAC,cAAc,CAAC,eAAe,CAAC,wBAAwB,CAAC;;AAE1K,cAAc;AACd,SAAS,YAAY,CAAC,2BAA2B,CAAC;AAClD,YAAY,YAAY,CAAC;AACzB,WAAW,YAAY,CAAC,oBAAoB,CAAC,QAAQ,CAAC,aAAa,CAAC;AACpE,cAAc,QAAQ,CAAC,eAAe,CAAC,cAAc;AACrD,OAAO,UAAU,CAAC,cAAc;AAChC,YAAY,aAAa,CAAC,UAAU;;AAEpC,mBAAmB;AACnB,SAAS,0BAA0B,CAAC,iCAAiC,CAAC,iBAAiB,CAAC,YAAY,CAAC,kBAAkB,CAAC,qBAAqB,CAAC;;AAE9I,iBAAiB;AACjB,kBAAkB,eAAe,CAAC,cAAc,CAAC,kBAAkB,CAAC,UAAU,CAAC,YAAY,CAAC,kBAAkB,CAAC,OAAO;;AAEtH;;;EAGE,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;;;EAGE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA,WAAW,YAAY,CAAC,gDAAgD,CAAC,QAAQ,CAAC,eAAe;;AAEjG,UAAU,YAAY,CAAC,OAAO;AAC9B,gBAAgB,cAAc,CAAC,UAAU;AACzC;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA,WAAW,kBAAkB,CAAC,YAAY,CAAC,cAAc,CAAC,QAAQ,CAAC,UAAU;AAC7E,YAAY,YAAY,CAAC,OAAO,CAAC,wBAAwB;AACzD,QAAQ,yBAAyB,CAAC,UAAU,CAAC,+BAA+B,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,cAAc;AAC9H,cAAc,eAAe,CAAC,UAAU,CAAC,wBAAwB;AACjE,iBAAiB,UAAU,CAAC,kBAAkB;;AAE9C,UAAU;AACV,YAAY,YAAY,CAAC,6BAA6B,CAAC,kBAAkB,CAAC,iBAAiB;AAC3F,eAAe,aAAa,CAAC,iCAAiC,CAAC,iBAAiB;AAChF,UAAU,UAAU,CAAC,wBAAwB,CAAC,eAAe,CAAC,gBAAgB;AAC9E,0BAA0B,iBAAiB,CAAC,wCAAwC,CAAC,cAAc;AACnG,mBAAmB,+BAA+B,CAAC,eAAe,CAAC,UAAU;AAC7E,kCAAkC,8BAA8B;AAChE,mCAAmC,kCAAkC;AACrE,SAAS,oCAAoC;AAC7C,gBAAgB,YAAY,CAAC,OAAO;;AAEpC,0BAA0B;AAC1B,UAAU,oBAAoB,CAAC,eAAe,CAAC,iBAAiB,CAAC,cAAc,CAAC,eAAe;AAC/F,eAAe,kBAAkB,CAAC,aAAa;AAC/C,gBAAgB,kBAAkB,CAAC,aAAa;AAChD,gBAAgB,kBAAkB,CAAC,aAAa;AAChD,eAAe,eAAe,CAAC,UAAU;AACzC,cAAc,kBAAkB,CAAC,aAAa;AAC9C,iBAAiB,kBAAkB,CAAC,aAAa;AACjD,eAAe,kBAAkB,CAAC,aAAa;AAC/C,iBAAiB,kBAAkB,CAAC,aAAa;AACjD,eAAe,kBAAkB,CAAC,aAAa;;;;;;;AAO/C,SAAS,oBAAoB,EAAE,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,WAAW;;;AAGhI,yBAAyB;AACzB,MAAM,YAAY,CAAC,OAAO,CAAC,cAAc,CAAC,kBAAkB;AAC5D,KAAK,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC,8BAA8B,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,oBAAoB,CAAC,UAAU;AAC7J,WAAW,kBAAkB;AAC7B,WAAW,mBAAmB,CAAC,UAAU;;AAEzC,gBAAgB;AAChB,SAAS,YAAY,CAAC,OAAO,CAAC,cAAc,CAAC,cAAc;;AAE3D,mBAAmB;AACnB,SAAS,YAAY,CAAC,6BAA6B,CAAC,QAAQ;AAC5D,eAAe,eAAe,CAAC,iBAAiB;;AAEhD,WAAW,YAAY,CAAC,eAAe,CAAC,KAAK,CAAC,eAAe;AAC7D,YAAY,eAAe;;AAE3B,qBAAqB;AACrB,aAAa,eAAe;;AAE5B,6BAA6B;AAC7B,QAAQ,YAAY,CAAC,OAAO,CAAC,qCAAqC,CAAC,kBAAkB;AACrF,QAAQ,8BAA8B,CAAC,eAAe,CAAC,eAAe,CAAC,gBAAgB,CAAC,yBAAyB,CAAC,cAAc;AAChI,eAAe,kBAAkB,CAAC,eAAe;;AAEjD,SAAS;AACT,OAAO,UAAU;AACjB,aAAa,cAAc;AAC3B,OAAO,eAAe;AACtB,QAAQ,YAAY,CAAC,kBAAkB,CAAC,OAAO;;;;;;AAM/C;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,cAAc;AAChB;;AAEA,2DAA2D;AAC3D,WAAW,kBAAkB,EAAE,wBAAwB,EAAE,WAAW;AACpE,cAAc,kBAAkB,EAAE,wBAAwB,EAAE,WAAW;AACvE,cAAc,eAAe,EAAE,qBAAqB,EAAE,WAAW;AACjE,MAAM,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,OAAO,EAAE,oBAAoB,EAAE;AACnH,QAAQ,cAAc;;;;;;AAMtB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;;;;;;;AAQA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;;;;;;;;;AAUA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* --- OpenCart Admin – Pixel-like Theme for your React app --- */\n\n/* Font to match OC admin */\n@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');\n\n:root{\n  --oc-bg: #f5f5f5;\n  --oc-panel: #ffffff;\n  --oc-border: #e3e3e3;\n  --oc-text: #333;\n  --oc-muted: #888;\n  --oc-blue: #23a1d1;       /* OC blue accents */\n  --oc-blue-700:#1f91bd;\n  --oc-blue-100:#e9f6fb;\n  --oc-table-head:#f7f7f7;\n  --oc-table-row:#fff;\n  --oc-table-row-alt:#fafafa;\n  --oc-danger:#d9534f;\n  --oc-success:#5cb85c;\n  --oc-warning:#f0ad4e;\n  --oc-link:#1e91bd;\n}\n\n/* Layout */\nhtml,body,#root{height:100%;}\nbody{margin:0;font-family:'Open Sans', Arial, sans-serif;color:var(--oc-text);background:var(--oc-bg);}\n\n/* main grid: sidebar + content */\n.oc-shell{display:grid;grid-template-columns: 230px 1fr;min-height:100vh;}\n.oc-sidebar{background:#1f2d3d;color:#cfd8dc;}\n.oc-brand{display:flex;align-items:center;gap:10px;padding:14px 16px;border-bottom:1px solid #202b35;}\n.oc-brand img{height:22px}\n.oc-nav{padding:8px 0;}\n.oc-nav .group-title{font-size:12px;color:#90a4ae;text-transform:uppercase;padding:10px 16px;}\n.oc-nav ul{margin:0;padding:0;list-style:none}\n.oc-nav li{display:block}\n.oc-nav a, .oc-nav button{display:flex;gap:8px;align-items:center;width:100%;padding:10px 16px;color:#cfd8dc;background:none;border:0;text-align:left;cursor:pointer}\n.oc-nav a:hover,.oc-nav button:hover{background:#17212b;color:#fff}\n.oc-nav li.active > a{background:#17212b;color:#fff}\n\n/* top bar */\n.oc-topbar{background:var(--oc-panel);border-bottom:1px solid var(--oc-border);height:54px;display:flex;align-items:center;padding:0 12px;gap:8px;}\n.oc-topbar-left {display:flex;align-items:center;gap:16px;margin-right:auto;}\n.oc-menu-btn {display:none;align-items:center;gap:8px;background:#fff;border:1px solid var(--oc-border);border-radius:4px;padding:6px 12px;cursor:pointer;color:var(--oc-text);font-size:13px;font-weight:600;}\n.oc-menu-btn:hover {background:var(--oc-table-head);}\n\n@media (max-width: 768px) {\n  .oc-shell {grid-template-columns: 1fr;}\n  .oc-sidebar {position:fixed;left:-230px;top:0;bottom:0;z-index:1000;transition:left 0.3s ease;}\n  .oc-shell.is-sidebar-open .oc-sidebar {left:0;}\n  .oc-menu-btn {display:flex;}\n  .oc-overlay {display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:999;}\n  .oc-shell.is-sidebar-open .oc-overlay {display:block;}\n}\n\n.oc-active-market-label {display:flex;align-items:center;gap:8px;color:var(--oc-blue);font-size:13px;font-weight:600;}\n.oc-ico-btn{border:1px solid var(--oc-border);background:#fff;border-radius:4px;padding:6px 10px;cursor:pointer}\n.oc-ico-btn.primary{background:var(--oc-blue);color:#fff;border-color:var(--oc-blue)}\n.oc-marketplace-switcher{display:flex;align-items:center;gap:6px;color:var(--oc-blue)}\n.oc-marketplace-switcher select{min-width:170px;max-width:240px;padding:5px 8px}\n.oc-user{display:flex;align-items:center;gap:10px;margin-left:6px}\n.oc-user-info{display:flex;flex-direction:column;align-items:flex-end;gap:1px;}\n.oc-user-name{font-size:12px;font-weight:600;line-height:1.2;color:var(--oc-text);}\n.oc-user-role{font-size:11px;color:var(--oc-muted);line-height:1.2;}\n.oc-avatar{width:32px;height:32px;border-radius:50%;background:#1f2d3d;color:#fff;display:grid;place-items:center;font-size:12px;font-weight:600;text-transform:uppercase;}\n\n/* page wrap */\n.oc-main{display:grid;grid-template-rows:54px 1fr;}\n.oc-content{padding:18px;}\n.oc-header{display:flex;align-items:baseline;gap:10px;margin:12px 0;}\n.oc-header h1{margin:0;font-weight:600;font-size:24px}\n.oc-bc{color:#999;font-size:13px}\n.oc-bc .sep{padding:0 6px;color:#bbb}\n\n/* cards / panels */\n.oc-card{background:var(--oc-panel);border:1px solid var(--oc-border);border-radius:4px;padding:12px;margin-bottom:16px;border:2px solid #000;}\n\n/* filter block */\n.oc-filter .title{font-weight:600;font-size:14px;margin-bottom:10px;color:#555;display:flex;align-items:center;gap:8px}\n\n.oc-filter .oc-f-grid,\n.oc-filter .orders-filter-grid,\n.oc-filter [style*=\"grid-template-columns\"] {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  gap: 8px !important;\n  align-items: flex-end !important;\n}\n\n.oc-filter .oc-field,\n.oc-filter [style*=\"grid-template-columns\"] > div {\n  flex: 1 1 140px !important;\n  min-width: 140px !important;\n  width: auto !important;\n}\n\n/* string inputs should be larger */\n.oc-filter .oc-field.large,\n.oc-filter .large,\n.oc-filter [style*=\"grid-template-columns\"] > div.large {\n  flex: 1 1 200px !important;\n  min-width: 200px !important;\n}\n\n.oc-filter .oc-checks,\n.oc-filter [style*=\"grid-template-columns\"] > div.oc-checks {\n  flex: 1 1 auto !important;\n  width: auto !important;\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.oc-filter .oc-actions,\n.oc-filter [style*=\"grid-template-columns\"] > div.oc-actions {\n  flex: 1 1 100% !important;\n  width: 100% !important;\n  margin-left: 0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.oc-f-grid{display:grid;grid-template-columns: repeat(5, minmax(0, 1fr));gap:12px;align-items:end}\n\n.oc-field{display:grid;gap:6px}\n.oc-field label{font-size:12px;color:#666}\n.oc-input, .oc-select {\n  height: 40px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  padding: 0 12px;\n  background: #fff;\n  font-size: 14px;\n  line-height: 1.5;\n  display: inline-block;\n  vertical-align: middle;\n}\n.oc-checks{grid-column:1 / -2;display:flex;flex-wrap:wrap;gap:14px;color:#333}\n.oc-actions{display:flex;gap:8px;justify-content:flex-end}\n.oc-btn{background:var(--oc-blue);color:#fff;border:1px solid var(--oc-blue);border-radius:3px;padding:6px 12px;cursor:pointer}\n.oc-btn.ghost{background:#fff;color:#333;border:1px solid #cfcfcf}\n.oc-btn:disabled{opacity:.5;cursor:not-allowed}\n\n/* table */\n.oc-toolbar{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px}\n.oc-table-wrap{overflow:auto;border:1px solid var(--oc-border);border-radius:4px}\n.oc-table{width:100%;border-collapse:collapse;background:#fff;min-width:1100px}\n.oc-table th,.oc-table td{padding:10px 12px;border-bottom:1px solid var(--oc-border);font-size:13px}\n.oc-table thead th{background:var(--oc-table-head);font-weight:600;color:#555}\n.oc-table tbody tr:nth-child(odd){background:var(--oc-table-row)}\n.oc-table tbody tr:nth-child(even){background:var(--oc-table-row-alt)}\n.oc-mono{font-family:Menlo,Consolas,monospace}\n.oc-row-actions{display:flex;gap:6px}\n\n/* status labels like OC */\n.oc-badge{display:inline-block;padding:3px 8px;border-radius:3px;font-size:12px;font-weight:600}\n.oc-badge.blue{background:#d9eef7;color:#1e6c8a}\n.oc-badge.green{background:#e2f4e6;color:#2e7d32}\n.oc-badge.amber{background:#fff0d6;color:#8a5a00}\n.oc-badge.gray{background:#eee;color:#555}\n.oc-badge.red{background:#fdecea;color:#c62828}\n.oc-badge.purple{background:#f3e5f5;color:#6a1b9a}\n.oc-badge.teal{background:#e0f2f1;color:#00695c}\n.oc-badge.orange{background:#fff3e0;color:#e65100}\n.oc-badge.pink{background:#fce4ec;color:#ad1457}\n\n\n\n\n\n\n.badge { display:inline-block; padding:3px 8px; border-radius:3px; font-size:12px; font-weight:600; background:#eee; color:#333 }\n\n\n/* tabs row within card */\n.tabs{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:10px}\n.tab{display:inline-flex;align-items:center;background:#fff;border:1px solid var(--border);border-radius:3px;padding:6px 10px;text-decoration:none;color:#333}\n.tab:hover{background:#f7f7f7}\n.tab.muted{pointer-events:none;color:#777}\n\n/* metrics row */\n.metrics{display:flex;gap:8px;flex-wrap:wrap;margin-top:6px}\n\n/* 2-column split */\n.split-2{display:grid;grid-template-columns:1fr 1fr;gap:16px}\n.section-title{font-weight:600;margin-bottom:6px}\n\n.store-row{display:flex;align-items:end;gap:8;margin-top:12px}\n.field.slim{max-width:280px}\n\n/* Add product card */\n.add-product{margin-top:12px}\n\n/* tabbar for notes/history */\n.tabbar{display:flex;gap:8px;border-bottom:1px solid var(--border);margin-bottom:12px}\n.tabbtn{border:1px solid var(--border);background:#fff;border-bottom:0;padding:6px 10px;border-radius:3px 3px 0 0;cursor:pointer}\n.tabbtn.active{background:#f7f7f7;font-weight:600}\n\n/* misc */\n.muted{color:#666}\n.muted.small{font-size:12px}\n.title{font-weight:600}\n.packed{display:flex;align-items:center;gap:6px}\n\n\n\n\n\n.order-summary-row{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:12px;\n}\n\n.order-actions{\n  display:flex;\n  gap:6px;\n  flex-wrap:wrap;\n}\n\n/* If you don't load Bootstrap, add minimal button colors */\n.btn-info{ background:#5bc0de; border:1px solid #46b8da; color:#fff }\n.btn-primary{ background:#337ab7; border:1px solid #2e6da4; color:#fff }\n.btn-default{ background:#fff; border:1px solid #ccc; color:#333 }\n.btn{ padding:6px 10px; border-radius:4px; display:inline-flex; align-items:center; gap:6px; text-decoration:none; }\n.btn i{ line-height:1 }\n\n\n\n\n\n.oc-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n.oc-modal {\n  background: #fff;\n  border-radius: 4px;\n  width: 800px;\n  max-width: 95%;\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);\n  border: 1px solid #ccc;\n}\n\n.oc-modal-header,\n.oc-modal-footer {\n  padding: 12px 16px;\n  border-bottom: 1px solid #eee;\n}\n\n.oc-modal-footer {\n  border-top: 1px solid #eee;\n  border-bottom: none;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.oc-modal-body {\n  padding: 12px 16px 4px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px 16px;\n  margin-bottom: 8px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.form-group.checkbox {\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n}\n\n.oc-input {\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n\n\n\n\n\n\n.oc-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.oc-table th,\n.oc-table td {\n  padding: 8px 10px;\n  border: 1px solid #ddd;\n  vertical-align: middle;\n}\n\n.oc-thumb {\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n}\n\n.oc-textarea {\n  min-height: 80px;\n  padding: 6px 8px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 14px;\n  resize: vertical;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px 16px;\n  margin-bottom: 8px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n\n\n\n\n\n\n\n\n.oc-image-upload {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.oc-image-upload-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.oc-input-file {\n  font-size: 13px;\n  padding: 4px 0;\n}\n\n.oc-btn-upload {\n  padding-inline: 12px;\n  height: 32px;\n  font-size: 13px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.oc-image-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.oc-image-input-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.oc-image-preview {\n  width: 120px;\n  height: 120px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.oc-image-preview-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.oc-field-error {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #b91c1c;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
